import { Component, OnInit, Input, SimpleChanges, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { FormControl } from '@angular/forms';
import { SaleService } from 'src/app/services/partner/sale.service';
import { MainService } from 'src/app/services/delavci/main.service';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { Sale } from 'src/app/models/Sale';
import { Router } from '@angular/router';
import { SaleParameters } from 'src/app/models/SaleParameters';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { SaleAllParameters } from 'src/app/models/SaleAllParameters';
import * as _ from 'underscore';
import { SaleOrder } from 'src/app/models/SaleOrder';
import { Subscription, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { GrafSkladiscePoslovalniceStolpicniComponent } from '../graf-skladisce-poslovalnice-stolpicni/graf-skladisce-poslovalnice-stolpicni.component';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'DD.MM.YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'DD.MM.YYYY',
  },
};
@Component({
  selector: 'app-sale-skladisce-desktop',
  templateUrl: './sale-skladisce-desktop.component.html',
  styleUrls: ['./sale-skladisce-desktop.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class SaleSkladisceDesktopComponent implements OnInit, OnDestroy {

  //@Input() saleType;
  public saleType = 'SALEVALUE';
  public dataList: Array<Sale>;
  public dateList: Array<string> = [];
  public dateListPoslovalnice: Array<string> = [];
  public spinner = true;
  public shouldBeExpanded;
  public showCountry;
  public saleFilter;
  public sortedDataArray;
  public showGraphBool = false;
  public showSettings = false;
  public firstInit = true;
  public showNaPlan: any;
  public showCmp: any;
  public sumDatesVarPlan: number;
  public isDataLoaded = false;
  public loopForAllCalls = ['SALE_DATE_PART_01', 'SALE_HOUR_01', 'SALE_DATE_IGRO_01']; // 'SALE_PART_01'
  public REPAPNL1: any;
  public reportId: SaleParameters;
  public showEURValues: number;
  public showTaxValues: number;
  public workerWarehouseTypes: SaleParameters[];
  public workerWarehouses;
  public workerWarehouseCountries: SaleParameters[];
  public order: SaleOrder;
  public sort: SaleOrder;
  public fetchLS: any;
  public groupType: SaleParameters;
  public samodejniDatum: any;
  public dateFromLS: any;
  public dateToLS: any;
  public dataListDatePart: any;
  public dataListSaleHour: any;
  public dataListDateIgro: any;
  public dataIgroDefined: boolean = false;
  public joinedParameters;
  public tableByCountries: Array<Array<Array<Sale>>> = [[]];
  public countryList: Array<string> = [];
  public sumDatesVar: number;
  public sumDatesVarCmp: any;
  public outCalcCmp: number;
  public outCalcPlan: number;
  public refreshTimerSub;
  public chbx_hitroOsvezevanje: boolean;
  titleList: any;
  public salePartJoinedArr: any[];
  constructor(private saleService: SaleService, private mainService: MainService, private router: Router, private _snackBar: MatSnackBar) { }

  ngOnInit() {
    if(!this.saleService.currentSaleParametersValue) {
      this.joinedParameters = {dateFrom: moment().startOf('month').format("DD.MM.YYYY"),
      dateTo: moment().format("DD.MM.YYYY"), chxb_datumZaDatum: false,
      chxb_samodejniDatum: true, chxb_prikaziDrzave: true,
      chxb_prikaziPoslovalnice: true, chxb_prikaziProcent: true,
      chxb_prikaziProcentNaPlan: true,
      chxb_DDV: true, chxb_EUR: true, chxb_razprto: false, reportsList: 50,
      fetch: 20};
      this.saleService.changeSaleParameters(this.joinedParameters);
    }

    this.parametersInit();
    this.dataIgroDefined = false;
    this.saleType = this.saleService.currentSaleTypeValue;

    this.mainService.prodajaSettingsBool.subscribe(data => {
      this.showSettings = data;
      if(this.showGraphBool) {
        this.showGraphBool = false;
      }
    });
    if(!this.saleService.currentSaleFilterValue){
      this.saleService.changeSaleFilter('SALEVALUE');
    }

    this.saleService.currentSaleFilter.subscribe( data => {
      this.saleFilter = data;
      if (this.router.url === '/prodaja/izbira/nadzorna_plosca') {
        if (this.saleFilter === 'MARGINPERCENT' || this.saleFilter === 'SALEVALUE' || this.saleFilter === 'SALEVALUEWT') {
        } else {
          this.saleService.changeSaleFilter('SALEVALUE');
        }
      }
      if(!this.firstInit) {
        this.sumAllDates();
      }
      this.getSalePart();
    }, error => {
      console.log(error);
    });

    this.saleService.currentSaleParameters.subscribe(data => {
      if(!this.firstInit){
        this.parametersInit();
        this.refreshTimerSub.unsubscribe();
        if(this.chbx_hitroOsvezevanje) {
          this.refreshTimerSub = timer(0, 300000).subscribe( () => this.callSaleWS());
        } else {
          this.refreshTimerSub = timer(0, 3600000).subscribe( () => this.callSaleWS());
        }
      }
    });
    if(this.chbx_hitroOsvezevanje) {
      this.refreshTimerSub = timer(0, 300000).subscribe( () => this.callSaleWS());
    } else {
      this.refreshTimerSub = timer(0, 3600000).subscribe( () => this.callSaleWS());
    }
    this.mainService.changeHref(this.router.url);
  }

  ngOnDestroy() {
    this.refreshTimerSub.unsubscribe();
}
  parametersInit() {
    this.REPAPNL1 = this.saleService.currentSaleParametersValue.timeCompare;
    this.reportId = this.saleService.currentSaleParametersValue.reportsList;
    this.showEURValues = this.saleService.currentSaleParametersValue.chxb_EUR ? 1 : 0;
    this.chbx_hitroOsvezevanje = this.saleService.currentSaleParametersValue.chbx_hitroOsvezevanje;
    this.workerWarehouseTypes = this.saleService.currentSaleParametersValue.typesList;
    this.workerWarehouses = this.saleService.currentSaleParametersValue.warehousesList;
    this.workerWarehouseCountries = this.saleService.currentSaleParametersValue.countriesList;
    this.order = this.saleService.currentSaleParametersValue.orderList;
    this.sort = this.saleService.currentSaleParametersValue.sortList;
    this.fetchLS = this.saleService.currentSaleParametersValue.fetch;
    this.groupType = this.saleService.currentSaleParametersValue.groupType;
    this.samodejniDatum = this.saleService.currentSaleParametersValue.chxb_samodejniDatum;
    this.shouldBeExpanded = this.saleService.currentSaleParametersValue.chxb_razprto;
    this.showCountry = this.saleService.currentSaleParametersValue.chxb_prikaziDrzave;
    this.showNaPlan = this.saleService.currentSaleParametersValue.chxb_prikaziProcentNaPlan;
    this.showCmp = this.saleService.currentSaleParametersValue.chxb_prikaziProcent;
  }

  callSaleWS() {
    if(this.firstInit) {
      this.firstInit = false;
    }
    this.dateFromLS;
    this.dateToLS;
    this.spinner = true;
    this.dataListDateIgro = null;
    for(let i = 0; i < this.loopForAllCalls.length; i++){
      this.DatePartCallWS(i);
    }
  }

  DatePartCallWS(i) {
    this.spinner = true;
    if(this.saleService.currentSaleParametersValue) {

      if (this.samodejniDatum) {
        this.dateFromLS = (moment().startOf('month')).format("DD.MM.YYYY");
        this.dateToLS = (moment()).format("DD.MM.YYYY");
      } else {
        this.dateFromLS = this.saleService.currentSaleParametersValue.dateFrom;
        this.dateToLS = this.saleService.currentSaleParametersValue.dateTo;
      }
      this.saleService.sale(this.mainService.currentUserValue.sessionUser, this.dateFromLS,
        this.dateToLS, this.REPAPNL1, this.reportId, 1, this.showEURValues, this.workerWarehouseTypes,
        this.workerWarehouseCountries, this.order, this.sort, this.fetchLS, this.loopForAllCalls[i],
          this.groupType, this.workerWarehouses).subscribe( async data => {
          if(this.loopForAllCalls[i] === 'SALE_HOUR_01') {

            this.dataListSaleHour = data.data.sale;
            this.extractDates();
          } else if(this.loopForAllCalls[i] === 'SALE_DATE_PART_01') {
            this.dataList = data.data.sale;
            for(let i = 0; i < this.dataList.length; i ++) {
              this.dataList[i].date = moment(this.dataList[i].date).format("DD.MM.YYYY");
            }
            this.extractCountries();
            this.extractDatesPoslovalnice();
            this.sortByDate();
            this.sumAllDates();
            this.getTitleList();
            this.getSalePart();
          } else if(this.loopForAllCalls[i] === 'SALE_DATE_IGRO_01') {
            this.dataListDateIgro = data.data.sale;
            for(let i = 0; i < this.dataListDateIgro.length; i ++) {
              this.dataListDateIgro[i].date = moment(this.dataListDateIgro[i].date).format("DD.MM.YYYY");
            }
            this.dataIgroDefined = true;
          } /*else if(this.loopForAllCalls[i] === 'SALE_PART_01') {
            this.dataListDatePart = data.data.sale;
          }*/

          if(this.dataList && this.dataListDateIgro && this.dataListSaleHour /*&&  this.dataListDatePart*/ ) {
            this.isDataLoaded = true;
            this.spinner = false;
          }

        }, error => {
          console.log(error);
          this.spinner = false;
          this.openSnackBar(error.message);
        });
    } else {
      this.dateFromLS = moment().startOf('month').format('DD.MM.YYYY');
      this.dateToLS = moment().format('DD.MM.YYYY');
      this.saleService.saleNoParams(this.mainService.currentUserValue.sessionUser, this.dateFromLS,
        this.dateToLS, 1, null, /*null,*/ this.loopForAllCalls[i]).subscribe( data => {

          if(this.loopForAllCalls[i] === 'SALE_HOUR_01') {

            this.dataListSaleHour = data.data.sale;
            this.extractDates();
          } else if(this.loopForAllCalls[i] === 'SALE_DATE_PART_01') {
            this.dataList = data.data.sale;
            for(let i = 0; i < this.dataList.length; i ++) {
              this.dataList[i].date = moment(this.dataList[i].date).format("DD.MM.YYYY");
            }
            this.extractCountries();
            this.extractDatesPoslovalnice();
            this.sortByDate();
            this.sumAllDates();
            this.getTitleList();
            this.getSalePart();
          } else if(this.loopForAllCalls[i] === 'SALE_DATE_IGRO_01') {
            this.dataListDateIgro = data.data.sale;
            for(let i = 0; i < this.dataListDateIgro.length; i ++) {
              this.dataListDateIgro[i].date = moment(this.dataListDateIgro[i].date).format("DD.MM.YYYY");
            }
          }/* else if(this.loopForAllCalls[i] === 'SALE_PART_01') {
            this.dataListDatePart = data.data.sale;
          }*/
          if(this.dataList && this.dataListDateIgro && this.dataListSaleHour /*&&  this.dataListDatePart*/ ) {
            this.isDataLoaded = true;
            this.spinner = false;
          }
    }, error => {
      console.log(error);
      this.spinner = false;
      this.openSnackBar(error.message);
    });
    }
  }

  onFilterSubmit() {
    this.spinner = true;
    this.callSaleWS();
  }

  roundingToolNoDecimal(num) {
    return Math.round(num);
  }


  showGraph() {
    if(this.showGraphBool) {
      this.showGraphBool = false;
    } else {
      this.showGraphBool = true;
    }
  }

  openSnackBar(message: string) {
    this._snackBar.open(message, '', {
      duration: 2000,
    });
  }

  sortByDate() {
    for(let i = 0; i < this.dateListPoslovalnice.length; i++) {
      this.tableByCountries[i] = [];
      for(let j = 0; j < this.countryList.length; j++) {
        this.tableByCountries[i][j] = [];
        for(let k = 0; k < this.dataList.length; k++) {
          if(this.dateListPoslovalnice[i] === this.dataList[k].date && this.countryList[j] === this.dataList[k].country) {
            this.tableByCountries[i][j].push(this.dataList[k]);
          }
        }
      }
    }
  }

  extractDatesPoslovalnice() {
    for(let i = 0; i < this.dataList.length; i ++) {

      if (!this.dateListPoslovalnice.includes(this.dataList[i].date.toString())) {
        this.dateListPoslovalnice.push(this.dataList[i].date);
      }
    }
  }

  // spodnjo kodo rabim za gauge graf
  extractCountries() {
    for(let i = 0; i < this.dataList.length; i ++) {
      if (!this.countryList.includes(this.dataList[i].country.toString())) {
        this.countryList.push(this.dataList[i].country);
      }
    }
  }

  extractDates() {
    for(let i = 0; i < this.dataListSaleHour.length; i ++) {

      if (!this.dateList.includes(this.dataListSaleHour[i].date.toString())) {
        this.dateList.push(this.dataListSaleHour[i].date);
      }
    }
  }

  sumAllDates() {
    this.sumDatesVarPlan = 0;
    this.sumDatesVar = 0;
    this.sumDatesVarCmp = 0;
    for(let k = 0; k < this.tableByCountries.length; k++) {
      for(let i = 0; i < this.tableByCountries[k].length; i++){
        for(let j = 0; j < this.tableByCountries[k][i].length; j++){
          if(this.saleFilter === 'SALEVALUE') {
            this.sumDatesVar += this.tableByCountries[k][i][j].saleVal;
            this.sumDatesVarCmp += this.tableByCountries[k][i][j].saleValCmp;
            this.sumDatesVarPlan += this.tableByCountries[k][i][j].saleValPlan;
          } else if(this.saleFilter === 'MARGINPERCENT') {
            this.sumDatesVar += this.tableByCountries[k][i][j].marginPrc;
            this.sumDatesVarCmp += this.tableByCountries[k][i][j].marginPrcCmp;
            this.sumDatesVarPlan += this.tableByCountries[k][i][j].marginValPlan;
          } else if (this.saleFilter === 'SALEVALUEWT') {
            this.sumDatesVar += this.tableByCountries[k][i][j].saleValWT;
            this.sumDatesVarCmp += this.tableByCountries[k][i][j].saleValWTCmp;
            this.sumDatesVarPlan += this.tableByCountries[k][i][j].saleValWTPlan;
          } else if (this.saleFilter === 'QUANTITY') {
            this.sumDatesVar += this.tableByCountries[k][i][j].quantity;
            this.sumDatesVarCmp += this.tableByCountries[k][i][j].quantityCmp;
          } else if (this.saleFilter === 'DOCUMENTCOUNT') {
            this.sumDatesVar += this.tableByCountries[k][i][j].docCount;
            this.sumDatesVarCmp += this.tableByCountries[k][i][j].docCountCmp;
          } else if (this.saleFilter === 'ITEMCOUNT') {
            this.sumDatesVar += this.tableByCountries[k][i][j].itemCount;
            this.sumDatesVarCmp += this.tableByCountries[k][i][j].itemCountCmp;
          }
        }
      }
    }
    this.allDateCalcCmp();
  }

  allDateCalcCmp() {
    if (this.sumDatesVarCmp == 0) {
        this.outCalcCmp = 0;
      } else {
        this.outCalcCmp = (this.sumDatesVar / this.sumDatesVarCmp ) * 100;
      }

      if (this.sumDatesVarPlan == 0) {
        this.outCalcPlan = 0;
      } else {
        this.outCalcPlan = (this.sumDatesVar / this.sumDatesVarPlan ) * 100;
      }
  }

  getTitleList() {
    this.titleList = [];
    for(let i = 0; i < this.dataList.length; i ++) { {
      if(!this.titleList.includes(this.dataList[i].title)) {
        this.titleList.push(this.dataList[i].title);
      }

     }

    }
  }

  getSalePart() {
    let titleList: Array<string>;
    let sum;
    let sumCmp;
    let sumPlan;
    this.salePartJoinedArr = []; // country , title, saleVal, saleValCmp, saleValPlan , margin... , WT...
    for(let i = 0; i < this.countryList.length; i++) {

      for(let a = 0; a < this.titleList.length; a++) {
        sum = 0;
        sumCmp = 0;
        sumPlan = 0;
        for(let j = 0; j < this.tableByCountries.length; j++) {

          for(let k = 0; k < this.tableByCountries[j].length; k++) {

            for(let l = 0; l < this.tableByCountries[j][k].length; l++) {

              if (this.countryList[i] === this.tableByCountries[j][k][l].country &&
                 this.titleList[a] == this.tableByCountries[j][k][l].title) {
                  if(this.saleFilter === 'SALEVALUE') {
                    sum += this.tableByCountries[j][k][l].saleVal;
                    sumCmp += this.tableByCountries[j][k][l].saleValCmp;
                    sumPlan += this.tableByCountries[j][k][l].saleValPlan;
                  } else if(this.saleFilter === 'MARGINPERCENT') {
                    sum += this.tableByCountries[j][k][l].marginPrc;
                    sumCmp += this.tableByCountries[j][k][l].marginPrcCmp;
                    sumPlan += this.tableByCountries[j][k][l].marginValPlan;
                  } else if (this.saleFilter === 'SALEVALUEWT') {
                    sum += this.tableByCountries[j][k][l].saleValWT;
                    sumCmp += this.tableByCountries[j][k][l].saleValWTCmp;
                    sumPlan += this.tableByCountries[j][k][l].saleValWTPlan;
                  }
                }
              }
          }
        }

        if(this.saleFilter === 'SALEVALUE') {
          this.salePartJoinedArr.push({date: '', country: this.countryList[i], title: this.titleList[a], saleVal: sum, saleValCmp: sumCmp, saleValPlan: sumPlan});
        } else if(this.saleFilter === 'MARGINPERCENT') {
          this.salePartJoinedArr.push({date: '', country: this.countryList[i], title: this.titleList[a], marginPrc: sum, marginPrcCmp: sumCmp, marginPrcPlan: sumPlan});
        } else if (this.saleFilter === 'SALEVALUEWT') {
          this.salePartJoinedArr.push({date: '', country: this.countryList[i], title: this.titleList[a], saleValWT: sum, saleValWTCmp: sumCmp, saleValWTPlan: sumPlan});
        }
      }
    }
  }

}
